import { TranslateDefaultParser, TranslateParser } from '@ngx-translate/core';

class NamespacedTranslateParser extends TranslateDefaultParser {
  constructor(protected readonly namespace: string) {
    super();
  }

  getValue(target: any, key: string): any {
    return super.getValue(target, this.namespace + '.' + key) ?? super.getValue(target, key);
  }
}

/**
 * Creates a namespaced translate parser that can be used as the counterpart to a namespaced TranslateLoader. It internally prefixes given
 * translation keys with the namespace. If a translation key is not found in the namespace, the key is looked up without the namespace.
 *
 * @example
 * ```typescript
 * TranslateModule.forChild({
 *   //...
 *   parser: { provide: TranslateParser, useFactory: createNamespacedTranslateParser('myNamespace') },
 * })
 * ```
 * @see createNamespacedTranslateLoader
 * @param {string} namespace The namespace which is used to resolve the translation keys
 * @returns {TranslateParser} The namespaced translate parser
 */
export function createNamespacedTranslateParser(namespace: string): TranslateParser {
  return new NamespacedTranslateParser(namespace);
}
